const RANKING = [
  { rank: 1, title: '犯罪都市4', meta: '韩国 · 动作犯罪', hot: '🔥 9.8', tag: '新片' },
  { rank: 2, title: '你想活出怎样的人生', meta: '日本 · 动画奇幻', hot: '🔥 9.7', tag: '热门' },
  { rank: 3, title: '破墓', meta: '韩国 · 恐怖悬疑', hot: '🔥 9.5', tag: '热门' },
  { rank: 4, title: '首尔之春', meta: '韩国 · 历史剧情', hot: '🔥 9.4', tag: '经典' },
  { rank: 5, title: '鬼灭之刃 无限城篇', meta: '日本 · 动画动作', hot: '🔥 9.3', tag: '新片' },
  { rank: 6, title: '余生那些年', meta: '日本 · 爱情剧情', hot: '🔥 9.1', tag: '热播' },
  { rank: 7, title: '杀人者的购物中心', meta: '韩国 · 悬疑剧集', hot: '🔥 9.0', tag: '剧集' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">热播榜单</h2>
        <p className="text-sm text-foreground-500 mb-8">全网日韩电影热度排名，实时更新</p>
        <div className="space-y-3">
          {RANKING.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors group cursor-pointer"
            >
              <div className={`w-9 h-9 flex items-center justify-center rounded-lg font-heading text-lg font-bold flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <span className={`text-[10px] px-1.5 py-0.5 rounded whitespace-nowrap font-medium ${
                    item.tag === '新片' ? 'bg-primary-100 text-primary-700' :
                    item.tag === '热门' ? 'bg-accent-100 text-accent-700' :
                    item.tag === '经典' ? 'bg-secondary-100 text-secondary-700' :
                    item.tag === '热播' ? 'bg-accent-100 text-accent-700' :
                    'bg-secondary-100 text-secondary-700'
                  }`}>{item.tag}</span>
                </div>
                <p className="text-xs text-foreground-500 mt-0.5">{item.meta}</p>
              </div>
              <div className="text-sm font-bold text-accent-600 whitespace-nowrap">{item.hot}</div>
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 group-hover:bg-primary-100 transition-colors flex-shrink-0">
                <i className="ri-play-fill text-foreground-500 group-hover:text-primary-500 transition-colors"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}